module.exports = __webpack_public_path__ + "img/block-meh.9d700520.jpg";